/**
 * O que o portal fez e o que ficou pendente no Jira de uma implantação (console interno).
 *
 * **Pendência é espera, não erro.** Jira desligado, sem épico ou sem transição aparecem aqui com o
 * motivo escrito pelo servidor; o reprocessamento cumpre sozinho quando o obstáculo some. A tela
 * lista e não alarma: o aceite do kickoff nunca depende do Jira.
 */
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { pedirJson } from "./api";

export const PERMISSAO_DE_VER_O_JIRA = "console:ver";

const esquemaPendencia = z.object({ assunto: z.string(), motivo: z.string() });

export const esquemaJiraDaImplantacao = z.object({
  jira_epic_key: z.string().nullable(),
  etapa_desejada: z.string().nullable(),
  etapa_observada: z.string().nullable(),
  etapa_desejada_atendida_em: z.string().nullable(),
  pendencias: z.array(esquemaPendencia),
});

export type JiraDaImplantacao = z.infer<typeof esquemaJiraDaImplantacao>;

export const CHAVE_RAIZ_DO_JIRA = ["implantacoes", "jira"] as const;
export const chaveDoJiraDaImplantacao = (implantacaoId: string) =>
  [...CHAVE_RAIZ_DO_JIRA, implantacaoId] as const;

export function useJiraDaImplantacao(implantacaoId: string, habilitado: boolean) {
  return useQuery<JiraDaImplantacao>({
    queryKey: chaveDoJiraDaImplantacao(implantacaoId),
    queryFn: ({ signal }) =>
      pedirJson(
        `/implantacoes/${encodeURIComponent(implantacaoId)}/jira`,
        esquemaJiraDaImplantacao,
        { signal },
      ),
    enabled: habilitado && implantacaoId.length > 0,
    retry: false,
  });
}
